module.exports = __webpack_public_path__ + "static/media/icon-download-light-blue.32368f6b.svg";